import React from "react";
import './Prizes.css';
import ContestPrizes01 from "../../../static/img/Trader/ContestAll/BitcoinMain.jpg";
import ContestMenu from "./ContestMenu/ContestMenu";
import LayoutMain from "../../00LayoutMain/LayoutMain";
import SendQuestion from "../../00LayoutMain/TopMenu/SendQuestion/SendQuestion";
import TextChange from "../../../../AdminPart/src/Elements/TextChange/TextChange";

    function GatsbyContestPrizesSource (props) {
        function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
        } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}

        const MenuTop = [{Link : '',Name : props.PrerenderTexts['ContestPrizes0055'] ? JSON.parse(props.PrerenderTexts['ContestPrizes0055'])[props.lang] : '*Все конкурсы'},
        {Link : '/result/',Name : props.PrerenderTexts['ContestPrizes0060'] ? JSON.parse(props.PrerenderTexts['ContestPrizes0060'])[props.lang] : '*Результаты прошлых'},
        {Link : '/prizes/',Name : props.PrerenderTexts['ContestPrizes0065'] ? JSON.parse(props.PrerenderTexts['ContestPrizes0065'])[props.lang] : '*Получить приз'},
    ];

    return (
        <LayoutMain title={props.title} description={props.description} lang={props.lang}>
            <main className="TraderContestOut StandartPage">
                <div className="StandartNOTitle"/>

                <div className="StandartWhitePart TraderContest">
                    <div className="StandartWhitePartTitle">
                        <div className="StandartWhitePartTitleText">
                            <TextSource ArrIndex= 'ContestPrizes0015'>Выплата призов по всем конкурсам</TextSource>
                        </div>
                        <SendQuestion lang={props.lang}/>
                    </div>
                    <ContestMenu lang={props.lang} Menu={MenuTop}/>

                    <div className="ContestPrizesGridOut">
                        <div className="ContestPrizesGrid">
                            <div className="ContestPrizesGridLeft">
                                <img src={ContestPrizes01} alt='Ifyoudontseeimages'/>
                            </div>
                            <div className="ContestPrizesGridRight">
                                <div className="ContestPrizesGridRightIn">
                                    <div className="ContestPrizesGridRightText01"><TextSource ArrIndex= 'ContestPrizes0020'>Уважаемые участники конкурса - для получения приза</TextSource> </div>
                                    <div className="ContestPrizesGridRightText02"><TextSource ArrIndex= 'ContestPrizes0025'>Вам необходимо выслать письмо на почту </TextSource> 
                                        <b><TextSource ArrIndex= 'ContestPrizes0030'>contest@fxbitcoin.org</TextSource> </b>
                                    </div>
                                    <div className="ContestPrizesGridRightTitle"><TextSource ArrIndex= 'ContestPrizes0035'>В письме укажите</TextSource> </div>
                                    <div className="TraderContestTopGridTextList">
                                        <div className="TraderContestTopGridTextListElement"><TextSource ArrIndex= 'ContestPrizes0040'>Номер конкурсного счета</TextSource> </div>
                                        <div className="TraderContestTopGridTextListElement"><TextSource ArrIndex= 'ContestPrizes0045'>Место, которое Вы заняли на конкурсе и ссылку на результаты</TextSource> </div>
                                        <div className="TraderContestTopGridTextListElement"><TextSource ArrIndex= 'ContestPrizes0050'>Номер торгового счета, на который следует перечислить средства</TextSource> </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </LayoutMain>

    )}

export default GatsbyContestPrizesSource